import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import { Main, Filter } from 'Containers/';
import { TitledCard } from 'Components/';
import { MONTH_YEAR_DATE_FORMAT } from 'Common/Constants';
import { NC_SFS_4_FORM_NAME } from 'Common/FormEnum';
import { withReportSubscription } from 'State/report/withReportSubscription';
import { NCSFS4FieldEnum as Fields } from 'Common/FieldEnum';
import { getControlInfo } from 'State/controlInfo/actions';
import { getFiscalYearStart } from 'State/selectors';

import { NCSFS4Form } from './components/NCSFS4Form';

const now = moment().format(MONTH_YEAR_DATE_FORMAT);

class NCSFS4 extends Component {
  componentDidMount() {
    const { getControlInfo } = this.props;
    getControlInfo();
  }

  get mainProps() {
    const { submit, reportFetching } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            loading: reportFetching,
            disabled: reportFetching,
            content: 'View',
            onClick: () => submit(NC_SFS_4_FORM_NAME),
          },
        ],
        shown: true,
      },
    };
  }

  onSubmit = values => {
    const { getReport } = this.props;
    getReport('reports/NCSFS4Report', values);
  };

  render() {
    const { fiscalYearStart } = this.props;
    return (
      <Fragment>
        <Filter title="NC SFS-4 Report" />
        <Main {...this.mainProps}>
          <TitledCard title="Filters">
            <NCSFS4Form
              initialValues={{
                [Fields.From]: now,
                [Fields.To]: now,
                [Fields.FiscalYearToDate]: false,
                [Fields.SummaryOnly]: false,
              }}
              onSubmit={this.onSubmit}
              fiscalYearStart={fiscalYearStart}
            />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  fiscalYearStart: getFiscalYearStart(state),
});

const mapDispatchToProps = {
  getControlInfo,
};

NCSFS4 = withReportSubscription(NCSFS4);
NCSFS4 = connect(mapStateToProps, mapDispatchToProps)(NCSFS4);

NCSFS4.path = '/ncsfs-4';

export { NCSFS4 };



// WEBPACK FOOTER //
// ./src/pages/ncsfs4/NCSFS4.js